import { Facebook, Instagram, Twitter } from 'lucide-react';
import { Link } from 'react-router-dom';
import { BrandLogo } from './brand';

/**
 * Footer — reproduction fidèle de src/components/Footer.tsx du repo
 * Loveable : layout `xl:grid-cols-3 xl:gap-8`, colonne marque +
 * description + réseaux sociaux à gauche, 4 colonnes Société / Support /
 * Légal / Offres à droite, copyright centré.
 */
export function SiteFooter() {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="space-y-4 xl:col-span-1">
            <BrandLogo />
            <p className="text-sm text-gray-600 max-w-xs">
              BCL Telecom et Énergie vous accompagne dans le raccordement de la
              fibre optique et dans tous vos besoins en télécommunications.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                aria-label="Facebook"
                className="text-gray-500 hover:text-bcl-blue"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="#"
                aria-label="Instagram"
                className="text-gray-500 hover:text-bcl-blue"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="#"
                aria-label="Twitter"
                className="text-gray-500 hover:text-bcl-blue"
              >
                <Twitter className="h-5 w-5" />
              </a>
            </div>
          </div>
          <div className="mt-12 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm font-semibold text-gray-900">Société</h3>
                <ul className="mt-4 space-y-3">
                  <li>
                    <Link
                      to="/about"
                      className="text-sm text-gray-600 hover:text-bcl-blue"
                    >
                      À propos
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/services"
                      className="text-sm text-gray-600 hover:text-bcl-blue"
                    >
                      Nos services
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/contact"
                      className="text-sm text-gray-600 hover:text-bcl-blue"
                    >
                      Nous contacter
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="mt-12 md:mt-0">
                <h3 className="text-sm font-semibold text-gray-900">Support</h3>
                <ul className="mt-4 space-y-3">
                  <li>
                    <Link
                      to="/faq"
                      className="text-sm text-gray-600 hover:text-bcl-blue"
                    >
                      FAQ
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/assistance"
                      className="text-sm text-gray-600 hover:text-bcl-blue"
                    >
                      Assistance technique
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/status"
                      className="text-sm text-gray-600 hover:text-bcl-blue"
                    >
                      État du réseau
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm font-semibold text-gray-900">Légal</h3>
                <ul className="mt-4 space-y-3">
                  <li>
                    <Link
                      to="/privacy"
                      className="text-sm text-gray-600 hover:text-bcl-blue"
                    >
                      Politique de confidentialité
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/terms"
                      className="text-sm text-gray-600 hover:text-bcl-blue"
                    >
                      Conditions d&apos;utilisation
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/cookies"
                      className="text-sm text-gray-600 hover:text-bcl-blue"
                    >
                      Gestion des cookies
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="mt-12 md:mt-0">
                <h3 className="text-sm font-semibold text-gray-900">Offres</h3>
                <ul className="mt-4 space-y-3">
                  <li>
                    <Link
                      to="/offres/fibre"
                      className="text-sm text-gray-600 hover:text-bcl-blue"
                    >
                      Fibre optique
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/offres/entreprise"
                      className="text-sm text-gray-600 hover:text-bcl-blue"
                    >
                      Solutions entreprises
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/offres/promotions"
                      className="text-sm text-gray-600 hover:text-bcl-blue"
                    >
                      Promotions
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-12 border-t border-gray-200 pt-8">
          <p className="text-sm text-gray-500 text-center">
            &copy; {new Date().getFullYear()} BCL Telecom et Énergie. Tous
            droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
}
